import React, {Component} from 'react';

/**
 * Post-logout landing page.
 *
 * The Keycloak SSO session has already been terminated by the time this
 * renders. Forward to Discourse, whose "Portal Logout Bridge" theme component
 * clears the forum session and returns the user to the portal home page.
 */
class LoggedOut extends Component {

    componentDidMount() {
        const forumUrl = localStorage.getItem('forum_url');
        if (forumUrl) {
            window.location.replace(forumUrl + '?xlogout=1');
        }
    }

    render() {
        return (
            <>
                <div className="content about">
                    <h1 className="page-title">
                        Signing you out&hellip;
                    </h1>
                    <p>
                        If you are not redirected, <a href="/">return to the home page</a>.
                    </p>
                </div>
            </>
        )
    }
}

export default LoggedOut;
